import template from './klarna-select-payment-codes.html.twig';

const { Component } = Shopware;

Component.extend('klarna-select-payment-codes', 'sw-multi-select', {
    template
});
